
// NATIVE 


// INSTALLED 
import { Dispatch } from 'redux';


// CUSTOM 
import { activeCustomerService, desactiveCustomerService, 
         getAllCustomerByPaginateService, 
         getAllCustomerByParamService, getAllCustomerService, 
         getDetailCustomerService, setCustomerService, updateCustomerService } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { hideIconRequestErrors, showIconRequestErrors } from '../errors';
import { setCustomerRedux, setCustomersRedux, updateCustomerListRedux } from './customerSlice';
// import { updateStatusRowTblPaginate } from '../../commons/utils';
import { types } from '../../commons/types/types';






export const saveCustomer = (customer:any, setPercentajeCCompany: any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const { name,
                address,
                email,
                person_in_charge,
                contact,
                second_person_in_charge,
                second_customer_contact,
                phone,
                start_date,
                country,
                departament,
                municipaly,
                permissions }:any = customer;


               
        const data_save = {

                  name, 
                  address, 
                  email,
                  person_in_charge, 
                  contact: contact.toString(),
                  second_person_in_charge, 
                  second_customer_contact: second_customer_contact.toString(), 
                  phone: phone.toString(),
                  country: country.value, 
                  departament: departament.value,
                  municipaly: municipaly.value,
                  start_date, 
                  type_plan : "65fbb619b866f185b9b201bf",
                  permissions 
              
        }

        await dispatch( hideIconRequestErrors() );

        const result = await setCustomerService(data_save, setPercentajeCCompany);

        ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
        
       dispatch( unCheckingPreload() );

        return result;
        
    }
}





  export const editCustomer = (customer:any, setPercentajeCCompany: any): any => {

    return async( dispatch: any ) => {

        dispatch( checkingPreload() );

        const { e_name,
                e_address,
                e_email,
                e_person_in_charge,
                e_contact,
                e_second_person_in_charge,
                e_second_customer_contact,
                e_phone,
                e_start_date,
                e_country,
                e_departament,
                e_municipaly,
                e_permissions,
                customerId }:any = customer;


              
        const data_save = {

                  name: e_name, 
                  address: e_address, 
                  email: e_email,
                  person_in_charge: e_person_in_charge, 
                  contact: e_contact.toString(),
                  second_person_in_charge: e_second_person_in_charge, 
                  second_customer_contact: e_second_customer_contact.toString(), 
                  phone: e_phone.toString(),
                  country: e_country.value, 
                  departament: e_departament.value,
                  municipaly: e_municipaly.value,
                  start_date: e_start_date, 
                  type_plan:  "65fbb619b866f185b9b201bf",
                  permissions: e_permissions,
                  customerId: customerId
        }

        console.log('ale canilla')
        console.log(data_save);
        // return false

        await dispatch( hideIconRequestErrors() );

        const result = await updateCustomerService(data_save);

        ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
        
      dispatch( unCheckingPreload() );

        return result;
        
    }
  }

  export const getCustomersStore = (): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );


      const result = await  getAllCustomerService();


      if ( result.ok ) {
          await dispatch( setCustomersRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

  }


  
  export const storeGetDetailCustomer = (customerId:string): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );


      const result = await  getDetailCustomerService(customerId);


      if ( result.ok ) {
          await dispatch( setCustomerRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

  }

  


  
  export const getCustomersByParamStore = (param:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );


      const result = await  getAllCustomerByParamService(param);


      if ( result.ok ) {
          await dispatch( setCustomersRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

  }


   
  
  export const getCustomersByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      await dispatch( hideIconRequestErrors() );


      const result = await  getAllCustomerByPaginateService(page);


      if ( result.ok ) {
          await dispatch( setCustomersRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

  }

  export const storeDesactiveCustomer = (customerId: string): any => {
      
  
    return async( dispatch: any ) => { 


        await dispatch( checkingPreload() );
        await dispatch( hideIconRequestErrors() );
  
        const result = await  desactiveCustomerService(customerId);
  
        // ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
        
        dispatch( unCheckingPreload() );
  
        return result;
  
    }
  
      
  }



  
  export const storeActiveCustomer = (customerId: string): any => {
      
  
    return async( dispatch: any ) => { 


        await dispatch( checkingPreload() );
        await dispatch( hideIconRequestErrors() );
  
        const result = await  activeCustomerService(customerId);
  
        // ( result.ok ) ? dispatch( hideIconRequestErrors() )  : dispatch( showIconRequestErrors() );
        
        dispatch( unCheckingPreload() );
  
        return result;
  
    }
  
      
  }